/* Claimed by God Designs — "Do You Know Your Bible?" trivia engine (with Kids / Teens / Adults versions) */
(function () {
  'use strict';

  var CODES = { quick: 'BIBLE5', daily: 'BIBLE10', riddle: 'BIBLE15', streak: 'BIBLESHIP' };
  var STREAK_GOAL = 5;

  /* Teens / general bank (also used for the product-page quick question) */
  var Q = [
    ['Who built the ark?', ['Moses', 'Noah', 'Abraham', 'David'], 1, 'Genesis 6'],
    ['How many days did God take to create the world before resting?', ['5', '6', '7', '8'], 1, 'Genesis 1–2'],
    ['Who was swallowed by a great fish?', ['Jonah', 'Elijah', 'Peter', 'Daniel'], 0, 'Jonah 1:17'],
    ['What did David use to defeat Goliath?', ['A sword', 'A spear', 'A sling and a stone', 'A bow'], 2, '1 Samuel 17'],
    ['Who was thrown into the lions\' den?', ['Joseph', 'Daniel', 'Samson', 'Paul'], 1, 'Daniel 6'],
    ['How many books are in the Bible?', ['39', '27', '66', '73'], 2, ''],
    ['Who received the Ten Commandments on Mount Sinai?', ['Aaron', 'Joshua', 'Moses', 'Elijah'], 2, 'Exodus 20'],
    ['What is the first book of the New Testament?', ['Mark', 'Matthew', 'Luke', 'Acts'], 1, ''],
    ['Who betrayed Jesus for thirty pieces of silver?', ['Peter', 'Thomas', 'Judas Iscariot', 'John'], 2, 'Matthew 26:15'],
    ['In what town was Jesus born?', ['Nazareth', 'Jerusalem', 'Bethlehem', 'Capernaum'], 2, 'Luke 2:4'],
    ['Who was the strongest man in the Bible, whose strength was in his hair?', ['Saul', 'Samson', 'Gideon', 'Goliath'], 1, 'Judges 16'],
    ['How many disciples did Jesus choose?', ['7', '10', '12', '70'], 2, 'Luke 6:13'],
    ['What did Jesus turn water into at the wedding in Cana?', ['Oil', 'Wine', 'Milk', 'Honey'], 1, 'John 2'],
    ['Who was the first man God created?', ['Abel', 'Adam', 'Seth', 'Enoch'], 1, 'Genesis 2'],
    ['Which sea did Moses part?', ['Dead Sea', 'Sea of Galilee', 'Red Sea', 'Mediterranean Sea'], 2, 'Exodus 14'],
    ['What is the shortest verse in the Bible?', ['"God is love."', '"Jesus wept."', '"Pray always."', '"Rejoice evermore."'], 1, 'John 11:35'],
    ['Who denied Jesus three times before the rooster crowed?', ['James', 'Peter', 'Andrew', 'Philip'], 1, 'Luke 22'],
    ['How many plagues did God send on Egypt?', ['7', '10', '12', '40'], 1, 'Exodus 7–12'],
    ['Who was sold into slavery by his brothers?', ['Benjamin', 'Judah', 'Joseph', 'Reuben'], 2, 'Genesis 37'],
    ['What is the longest book of the Bible?', ['Genesis', 'Isaiah', 'Psalms', 'Jeremiah'], 2, ''],
    ['Who was the mother of Jesus?', ['Martha', 'Elizabeth', 'Mary', 'Ruth'], 2, 'Luke 1'],
    ['How many days and nights did it rain during the flood?', ['7', '12', '40', '100'], 2, 'Genesis 7:12'],
    ['Which disciple walked on water toward Jesus?', ['John', 'Peter', 'James', 'Matthew'], 1, 'Matthew 14:29'],
    ['What fruit is traditionally associated with the Garden of Eden?', ['Fig', 'Apple', 'The Bible doesn\'t name the fruit', 'Pomegranate'], 2, 'Genesis 3'],
    ['Who was the wisest king of Israel?', ['Saul', 'David', 'Solomon', 'Hezekiah'], 2, '1 Kings 3'],
    ['Who wrote most of the letters in the New Testament?', ['Peter', 'Paul', 'John', 'James'], 1, ''],
    ['On which day did Jesus rise from the dead?', ['Friday', 'Saturday', 'Sunday', 'Monday'], 2, 'Luke 24:1'],
    ['What did God create on the first day?', ['Animals', 'Light', 'Man', 'Plants'], 1, 'Genesis 1:3'],
    ['Who was Ruth\'s mother-in-law?', ['Hannah', 'Naomi', 'Deborah', 'Esther'], 1, 'Ruth 1'],
    ['How many years did the Israelites wander in the wilderness?', ['7', '12', '40', '70'], 2, 'Numbers 14:33'],
    ['Which queen risked her life to save the Jewish people?', ['Bathsheba', 'Jezebel', 'Esther', 'Vashti'], 2, 'Esther 4'],
    ['Who was the tax collector who climbed a sycamore tree to see Jesus?', ['Levi', 'Zacchaeus', 'Nicodemus', 'Lazarus'], 1, 'Luke 19'],
    ['What did Jesus feed 5,000 people with?', ['2 fish and 5 loaves', '5 fish and 2 loaves', '7 loaves only', 'Manna'], 0, 'John 6'],
    ['Who was the first king of Israel?', ['David', 'Saul', 'Solomon', 'Samuel'], 1, '1 Samuel 10'],
    ['Whom did Jesus raise from the dead after four days?', ['Jairus\' daughter', 'Lazarus', 'Tabitha', 'The widow\'s son'], 1, 'John 11'],
    ['What is the last book of the Bible?', ['Jude', 'Acts', 'Revelation', 'Malachi'], 2, ''],
    ['Who was known as "the friend of God"?', ['Moses', 'Abraham', 'Enoch', 'Job'], 1, 'James 2:23'],
    ['Which prophet was taken to heaven in a chariot of fire?', ['Elisha', 'Elijah', 'Isaiah', 'Ezekiel'], 1, '2 Kings 2:11'],
    ['What was Paul\'s name before his conversion?', ['Silas', 'Simon', 'Saul', 'Stephen'], 2, 'Acts 13:9'],
    ['How many times did Peter have to forgive, according to Jesus?', ['7', '70', '77 (seventy times seven)', '12'], 2, 'Matthew 18:22'],
    ['Who interpreted Pharaoh\'s dreams about seven years of famine?', ['Daniel', 'Joseph', 'Moses', 'Jacob'], 1, 'Genesis 41'],
    ['What was the name of the garden where Jesus prayed before His arrest?', ['Eden', 'Gethsemane', 'Golgotha', 'Bethany'], 1, 'Matthew 26:36'],
    ['Who was the father of John the Baptist?', ['Zechariah', 'Joseph', 'Simeon', 'Zebedee'], 0, 'Luke 1'],
    ['Which book comes right after Psalms?', ['Ecclesiastes', 'Proverbs', 'Isaiah', 'Job'], 1, ''],
    ['What did Jacob\'s ladder reach?', ['The mountain', 'Heaven', 'The temple', 'The clouds'], 1, 'Genesis 28:12'],
    ['Who was Jesus\' earthly father?', ['James', 'Joseph', 'John', 'Jacob'], 1, 'Matthew 1'],
    ['Where was Jesus baptized?', ['Sea of Galilee', 'Jordan River', 'Red Sea', 'Pool of Siloam'], 1, 'Matthew 3'],
    ['How many sons did Jacob have?', ['7', '10', '12', '14'], 2, 'Genesis 35'],
    ['What is the "Golden Rule"?', ['Love money', 'Do to others as you would have them do to you', 'An eye for an eye', 'Honor the king'], 1, 'Matthew 7:12'],
    ['Who was left on the island of Patmos and wrote Revelation?', ['Paul', 'Peter', 'John', 'James'], 2, 'Revelation 1:9'],
    ['What is the fruit of the Spirit\'s first-named quality?', ['Joy', 'Peace', 'Love', 'Patience'], 2, 'Galatians 5:22'],
    ['What did the Israelites eat in the wilderness?', ['Fish', 'Manna', 'Figs', 'Barley'], 1, 'Exodus 16'],
    ['Which animal spoke to Balaam?', ['A lion', 'A donkey', 'A serpent', 'A raven'], 1, 'Numbers 22'],
    ['Who was the mother of Samuel who prayed for a son?', ['Sarah', 'Hannah', 'Rachel', 'Leah'], 1, '1 Samuel 1'],
    ['What is the greatest commandment, according to Jesus?', ['Do not steal', 'Love the Lord your God with all your heart', 'Keep the Sabbath', 'Honor your parents'], 1, 'Matthew 22:37'],
    ['How many people were saved on the ark?', ['2', '4', '8', '12'], 2, '1 Peter 3:20'],
    ['Who said "Here am I. Send me!"?', ['Jeremiah', 'Isaiah', 'Samuel', 'Moses'], 1, 'Isaiah 6:8'],
    ['Which city\'s walls fell after the Israelites marched around them?', ['Jerusalem', 'Jericho', 'Nineveh', 'Babylon'], 1, 'Joshua 6'],
    ['What did Esau sell his birthright for?', ['A robe', 'A bowl of stew', 'Thirty silver coins', 'A flock of sheep'], 1, 'Genesis 25'],
    ['Who was called "a man after God\'s own heart"?', ['Solomon', 'David', 'Josiah', 'Joshua'], 1, 'Acts 13:22'],
    ['In whose house did the prophet Elisha raise a boy from the dead?', ['The widow of Zarephath', 'The Shunammite woman', 'Naaman', 'Jezebel'], 1, '2 Kings 4']
  ];

  /* Kids bank: 3 simple choices */
  var QK = [
    ['Who built a big boat called the ark?', ['Moses', 'Noah', 'David'], 1, 'Genesis 6'],
    ['What did God make on the very first day?', ['Light', 'Dogs', 'Trees'], 0, 'Genesis 1:3'],
    ['Who was swallowed by a big fish?', ['Peter', 'Adam', 'Jonah'], 2, 'Jonah 1:17'],
    ['How many special friends (disciples) did Jesus choose?', ['3', '12', '100'], 1, 'Luke 6:13'],
    ['Where was baby Jesus laid after He was born?', ['A bed', 'A manger', 'A boat'], 1, 'Luke 2:7'],
    ['Who beat the giant Goliath?', ['David', 'Samson', 'Noah'], 0, '1 Samuel 17'],
    ['What did Jesus walk on?', ['Clouds', 'Fire', 'Water'], 2, 'Matthew 14:25'],
    ['What was the name of Jesus’ mother?', ['Martha', 'Mary', 'Ruth'], 1, 'Luke 1'],
    ['Which animals went into the ark?', ['Only birds', 'Only fish', 'Animals of every kind'], 2, 'Genesis 6:19–20'],
    ['What did God put in the sky as a promise after the flood?', ['A rainbow', 'A star', 'The moon'], 0, 'Genesis 9:13'],
    ['Who was put in a den of lions?', ['Jonah', 'Daniel', 'Paul'], 1, 'Daniel 6'],
    ['How many days did God work before He rested?', ['3', '10', '6'], 2, 'Genesis 2:2'],
    ['What did Zacchaeus climb so he could see Jesus?', ['A tree', 'A ladder', 'A roof'], 0, 'Luke 19:4'],
    ['What did a boy share so Jesus could feed 5,000 people?', ['Cookies', 'Bread and fish', 'Apples'], 1, 'John 6:9'],
    ['Who was the first man God made?', ['Noah', 'Abraham', 'Adam'], 2, 'Genesis 2'],
    ['What did Jesus turn water into at a wedding?', ['Wine', 'Milk', 'Lemonade'], 0, 'John 2'],
    ['What is the first book of the Bible?', ['Revelation', 'Genesis', 'Psalms'], 1, ''],
    ['Who led God’s people out of Egypt?', ['David', 'Peter', 'Moses'], 2, 'Exodus 14'],
    ['Which sea did God split open so His people could walk through?', ['The Red Sea', 'The Blue Sea', 'The Green Sea'], 0, 'Exodus 14:21'],
    ['On what day did Jesus rise from the dead?', ['Tuesday', 'Sunday', 'Friday'], 1, 'Luke 24:1'],
    ['Who was very strong when his hair was long?', ['Jonah', 'Joseph', 'Samson'], 2, 'Judges 16'],
    ['What special gift did Joseph’s dad give him?', ['A colorful coat', 'A bike', 'A puppy'], 0, 'Genesis 37:3'],
    ['Which animal talked to Balaam?', ['A cat', 'A donkey', 'A fish'], 1, 'Numbers 22:28'],
    ['Which baby was found in a basket in the river?', ['Samuel', 'David', 'Moses'], 2, 'Exodus 2'],
    ['What did God send to feed His people in the desert?', ['Manna', 'Pizza', 'Candy'], 0, 'Exodus 16'],
    ['In what town was Jesus born?', ['Rome', 'Bethlehem', 'Egypt'], 1, 'Luke 2:4'],
    ['What did Jesus say about little children?', ['Go away', 'Be quiet', 'Let them come to Me'], 2, 'Mark 10:14'],
    ['Which is the first fruit of the Spirit?', ['Love', 'Money', 'Speed'], 0, 'Galatians 5:22'],
    ['How did the walls of Jericho fall down?', ['A big storm', 'People shouted and blew trumpets', 'An elephant pushed them'], 1, 'Joshua 6:20'],
    ['Which boy heard God call his name at night?', ['Saul', 'Jonah', 'Samuel'], 2, '1 Samuel 3']
  ];

  /* Adults bank: deeper cuts */
  var QA = [
    ['Who was the high priest when Jesus was put on trial?', ['Annas', 'Caiaphas', 'Gamaliel', 'Eli'], 1, 'Matthew 26:57'],
    ['Which left-handed judge defeated King Eglon of Moab?', ['Ehud', 'Gideon', 'Jephthah', 'Othniel'], 0, 'Judges 3:15–21'],
    ['How many verses are in Psalm 119?', ['119', '150', '176', '200'], 2, 'Psalm 119'],
    ['Who was the father of Methuselah?', ['Lamech', 'Jared', 'Enoch', 'Seth'], 2, 'Genesis 5:21'],
    ['Which prophet was told to marry Gomer?', ['Amos', 'Hosea', 'Micah', 'Joel'], 1, 'Hosea 1:3'],
    ['In which city were the disciples first called Christians?', ['Jerusalem', 'Rome', 'Corinth', 'Antioch'], 3, 'Acts 11:26'],
    ['Who was Abraham’s nephew?', ['Lot', 'Laban', 'Nahor', 'Terah'], 0, 'Genesis 12:5'],
    ['Who led Israel into the Promised Land after Moses died?', ['Caleb', 'Aaron', 'Joshua', 'Eleazar'], 2, 'Joshua 1'],
    ['Which of these books never mentions God by name?', ['Ruth', 'Esther', 'Jonah', 'Nahum'], 1, 'Esther'],
    ['Who was the first Christian martyr?', ['James', 'Stephen', 'Peter', 'Philip'], 1, 'Acts 7'],
    ['In Jesus’ second feeding miracle, about how many men were fed?', ['5,000', '4,000', '3,000', '7,000'], 1, 'Matthew 15:38'],
    ['What was the name of Moses’ wife?', ['Zipporah', 'Miriam', 'Jochebed', 'Keturah'], 0, 'Exodus 2:21'],
    ['Which king saw the handwriting on the wall?', ['Nebuchadnezzar', 'Belshazzar', 'Darius', 'Cyrus'], 1, 'Daniel 5'],
    ['Who was healed of leprosy after dipping in the Jordan seven times?', ['Gehazi', 'Uzziah', 'Naaman', 'Miriam'], 2, '2 Kings 5:14'],
    ['What was Peter’s given name before Jesus renamed him?', ['Simon', 'Saul', 'Levi', 'Nathanael'], 0, 'John 1:42'],
    ['Which church in Revelation was called lukewarm?', ['Ephesus', 'Sardis', 'Laodicea', 'Smyrna'], 2, 'Revelation 3:16'],
    ['Who is traditionally credited with writing the book of Acts?', ['Paul', 'Luke', 'Mark', 'John'], 1, 'Luke 1:3; Acts 1:1'],
    ['Who was Timothy’s mother?', ['Lois', 'Eunice', 'Lydia', 'Priscilla'], 1, '2 Timothy 1:5'],
    ['On which mountain did Elijah challenge the prophets of Baal?', ['Sinai', 'Carmel', 'Horeb', 'Zion'], 1, '1 Kings 18'],
    ['Which disciple was a tax collector?', ['Thomas', 'Bartholomew', 'Matthew', 'Thaddaeus'], 2, 'Matthew 9:9'],
    ['What does "Immanuel" mean?', ['Prince of Peace', 'God with us', 'The Lord saves', 'Anointed one'], 1, 'Matthew 1:23'],
    ['Who was chosen to replace Judas as an apostle?', ['Barnabas', 'Matthias', 'Silas', 'Timothy'], 1, 'Acts 1:26'],
    ['How old was Abraham when Isaac was born?', ['75', '90', '100', '120'], 2, 'Genesis 21:5'],
    ['Which chapter is known as "the Love Chapter"?', ['Romans 8', '1 Corinthians 13', 'John 3', 'Galatians 5'], 1, '1 Corinthians 13'],
    ['Who hid 100 prophets in caves to protect them from Jezebel?', ['Obadiah', 'Elisha', 'Micaiah', 'Ahab'], 0, '1 Kings 18:4'],
    ['Which woman served as a judge of Israel?', ['Jael', 'Deborah', 'Hannah', 'Huldah'], 1, 'Judges 4:4'],
    ['How many churches are addressed in Revelation 2–3?', ['5', '7', '10', '12'], 1, 'Revelation 1:11'],
    ['Which book was the Ethiopian official reading when Philip met him?', ['Psalms', 'Isaiah', 'Jeremiah', 'Genesis'], 1, 'Acts 8:28–32'],
    ['Who was Ruth’s second husband?', ['Mahlon', 'Obed', 'Boaz', 'Elimelech'], 2, 'Ruth 4:13'],
    ['Which Gospel begins "In the beginning was the Word"?', ['Matthew', 'Mark', 'Luke', 'John'], 3, 'John 1:1']
  ];

  /* Riddles: adults */
  var R = [
    ['I am not a king, yet crowns are laid before me. I have no beginning and no end, and I sit on a throne of glory. Who am I?', ['King David', 'The Alpha and Omega', 'Solomon', 'Melchizedek'], 1, 'Revelation 1:8'],
    ['I was born twice but died only once. Who am I?', ['Adam', 'Enoch', 'Lazarus', 'Elijah'], 2, 'John 11'],
    ['I lived the longest of any man in Scripture, yet died before my father. Who am I?', ['Adam', 'Noah', 'Methuselah', 'Jared'], 2, 'Genesis 5:27'],
    ['I never died, yet I walked with God and was no more. Who am I?', ['Elijah', 'Enoch', 'Moses', 'Abel'], 1, 'Genesis 5:24'],
    ['I am spoken in the beginning, became flesh, and dwelt among men. What am I?', ['The Law', 'The Word', 'The Covenant', 'The Spirit'], 1, 'John 1:14'],
    ['Three days in darkness, I prayed and was set free — but I went to the city I did not want to see. Who am I?', ['Paul', 'Jonah', 'Daniel', 'Peter'], 1, 'Jonah 2–3'],
    ['I was the youngest of eight, forgotten in the field, yet oil was poured on my head. Who am I?', ['Joseph', 'Benjamin', 'David', 'Gideon'], 2, '1 Samuel 16'],
    ['I bloomed overnight, and by my budding a priest was chosen. What am I?', ['The burning bush', 'Aaron\'s rod', 'The fig tree', 'Jesse\'s stump'], 1, 'Numbers 17'],
    ['I hid two spies on my roof and hung a scarlet cord. Who am I?', ['Ruth', 'Rahab', 'Deborah', 'Abigail'], 1, 'Joshua 2'],
    ['I asked for wisdom and received riches too. Who am I?', ['Job', 'Daniel', 'Solomon', 'Nehemiah'], 2, '1 Kings 3'],
    ['My name means "laughter," and I was born when my parents were old. Who am I?', ['Isaac', 'Jacob', 'Samuel', 'Ishmael'], 0, 'Genesis 21'],
    ['I fought with 300 men and lamps in clay jars. Who am I?', ['Joshua', 'Gideon', 'Barak', 'Samson'], 1, 'Judges 7']
  ];

  /* Riddles: teens */
  var RT = [
    ['I lost my strength when I lost my hair. Who am I?', ['Absalom', 'Samson', 'Elisha', 'Esau'], 1, 'Judges 16'],
    ['I was a shepherd boy who became a king and wrote many songs. Who am I?', ['Saul', 'Solomon', 'David', 'Asaph'], 2, '1 Samuel 16; Psalms'],
    ['I was thrown in a pit, sold by my brothers, and became second-in-command of Egypt. Who am I?', ['Joseph', 'Moses', 'Daniel', 'Jacob'], 0, 'Genesis 37–41'],
    ['I was told not to look back, but I did. Who am I?', ['Miriam', 'Sarah', 'Lot’s wife', 'Rebekah'], 2, 'Genesis 19:26'],
    ['A bright light knocked me down on the road, and I went from persecutor to apostle. Who am I?', ['Peter', 'Saul (Paul)', 'Silas', 'Barnabas'], 1, 'Acts 9'],
    ['An angel told me I would be the mother of the Son of God. Who am I?', ['Elizabeth', 'Anna', 'Martha', 'Mary'], 3, 'Luke 1:30–31'],
    ['I was thrown into a fiery furnace with two friends, and a fourth man appeared in the fire. Who am I?', ['Shadrach', 'Jonah', 'Elijah', 'Daniel'], 0, 'Daniel 3:25'],
    ['I was a fisherman who once walked on water, until I looked at the waves. Who am I?', ['Andrew', 'John', 'Peter', 'James'], 2, 'Matthew 14:29–30']
  ];

  /* Riddles: kids (3 choices) */
  var RK = [
    ['I am big and wooden, full of animals, and I floated on a flood. What am I?', ['A barn', 'Noah’s ark', 'A raft'], 1, 'Genesis 7'],
    ['I was small but brave, and I beat a giant with one stone. Who am I?', ['David', 'Goliath', 'Saul'], 0, '1 Samuel 17'],
    ['I spent 3 days inside a big fish, and I prayed the whole time. Who am I?', ['Daniel', 'Noah', 'Jonah'], 2, 'Jonah 2'],
    ['I am a colorful promise God put in the sky. What am I?', ['The sun', 'A rainbow', 'A cloud'], 1, 'Genesis 9:13'],
    ['I was a baby floating in a basket on the river. Who am I?', ['Moses', 'Samson', 'Isaac'], 0, 'Exodus 2'],
    ['I was too short to see, so I climbed a tree, and Jesus came to my house. Who am I?', ['Peter', 'John', 'Zacchaeus'], 2, 'Luke 19'],
    ['I fell from the sky like little bread every morning. What am I?', ['Snow', 'Manna', 'Rain'], 1, 'Exodus 16'],
    ['I was a bright light that led the wise men to Jesus. What am I?', ['A star', 'A lamp', 'A campfire'], 0, 'Matthew 2:9']
  ];

  var BANK = { kids: QK, teens: Q, adults: QA };
  var RIDDLES = { kids: RK, teens: RT, adults: R };
  var AGE_LABEL = { kids: 'Kids', teens: 'Teens', adults: 'Adults' };

  function today() { var d = new Date(); return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(); }
  function dayIndex() { var d = new Date(); var s = new Date(d.getFullYear(), 0, 0); return Math.floor((d - s) / 864e5); }
  function weekIndex() { var d = new Date(); return Math.floor((d - new Date(d.getFullYear(), 0, 1)) / 6048e5) + d.getFullYear() * 60; }
  function get(k) { try { return JSON.parse(localStorage.getItem('cbgd_trivia_' + k)); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem('cbgd_trivia_' + k, JSON.stringify(v)); } catch (e) {} }
  function age() { var a = get('age'); return BANK[a] ? a : 'adults'; }
  function pick(arr, seed, n) {
    var out = [], used = {}, i = 0;
    while (out.length < n && i < arr.length * 3) {
      var idx = (seed * 7 + i * 13 + 5) % arr.length; i++;
      if (!used[idx]) { used[idx] = 1; out.push(arr[idx]); }
    }
    return out;
  }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }

  function rewardHTML(code, label) {
    return '<div class="cbgd-reward"><div class="cbgd-reward-label">' + label + '</div>' +
      '<div class="cbgd-code" data-code="' + code + '">' + code + '</div>' +
      '<div class="cbgd-reward-actions">' +
      '<button type="button" class="cbgd-btn cbgd-copy" data-code="' + code + '">Copy code</button>' +
      '<a class="cbgd-btn cbgd-apply" href="/discount/' + code + '?redirect=/collections/all">Apply &amp; shop</a>' +
      '</div><p class="cbgd-fine">One use per customer. Applied automatically at checkout when you click "Apply &amp; shop".</p></div>';
  }

  function bindCopy(root) {
    root.querySelectorAll('.cbgd-copy').forEach(function (b) {
      b.addEventListener('click', function () {
        var c = b.getAttribute('data-code');
        if (navigator.clipboard) navigator.clipboard.writeText(c);
        b.textContent = 'Copied!'; setTimeout(function () { b.textContent = 'Copy code'; }, 2000);
      });
    });
  }

  function renderQuestion(container, item, cb) {
    container.innerHTML = '';
    container.removeAttribute('data-done');
    var q = el('p', 'cbgd-q', item[0]);
    var opts = el('div', 'cbgd-opts');
    item[1].forEach(function (o, i) {
      var b = el('button', 'cbgd-opt', o); b.type = 'button';
      b.addEventListener('click', function () {
        if (container.getAttribute('data-done')) return;
        container.setAttribute('data-done', '1');
        var ok = i === item[2];
        b.classList.add(ok ? 'is-right' : 'is-wrong');
        if (!ok) opts.children[item[2]].classList.add('is-right');
        var fb = el('p', 'cbgd-fb ' + (ok ? 'ok' : 'no'),
          (ok ? '✓ Correct!' : '✗ Not quite — the answer is <strong>' + item[1][item[2]] + '</strong>.') +
          (item[3] ? ' <span class="cbgd-ref">(' + item[3] + ')</span>' : ''));
        container.appendChild(fb);
        setTimeout(function () { cb(ok); }, 900);
      });
      opts.appendChild(b);
    });
    container.appendChild(q); container.appendChild(opts);
  }

  function initQuick(root) {
    var body = root.querySelector('.cbgd-body');
    var state = get('quick') || {};
    if (state.date === today()) {
      body.innerHTML = state.won
        ? rewardHTML(CODES.quick, 'You already earned today\'s code:')
        : '<p class="cbgd-fb">You\'ve played today\'s question. Come back tomorrow, or try the <a href="/pages/daily-bible-trivia">Daily Trivia</a> for bigger rewards.</p>';
      bindCopy(body); return;
    }
    var item = Q[dayIndex() % Q.length];
    renderQuestion(body, item, function (ok) {
      set('quick', { date: today(), won: ok });
      var out = el('div');
      out.innerHTML = ok
        ? rewardHTML(CODES.quick, '🎉 You know your Bible! Take 5% off this order:')
        : '<p class="cbgd-fb">Keep studying! Try the <a href="/pages/daily-bible-trivia">Daily Trivia</a> for another chance at up to 15% off.</p>';
      body.appendChild(out); bindCopy(body);
    });
  }

  function initDaily(root) {
    var body = root.querySelector('.cbgd-body');
    var state = get('daily') || {};
    var streak = get('streak') || { count: 0, last: '' };
    var streakEl = root.querySelector('.cbgd-streak');
    var a = age();
    var tag = root.querySelector('.cbgd-age-now');
    if (tag) tag.textContent = AGE_LABEL[a] + ' questions';
    function paintStreak() {
      if (!streakEl) return;
      var dots = '';
      for (var i = 0; i < STREAK_GOAL; i++) dots += '<span class="cbgd-dot' + (i < streak.count ? ' on' : '') + '"></span>';
      streakEl.innerHTML = '<span>Streak: ' + streak.count + '/' + STREAK_GOAL + ' days</span>' + dots +
        (streak.count >= STREAK_GOAL ? rewardHTML(CODES.streak, '🔥 Five-day streak! Free shipping on your next order:') : '<small>Play ' + STREAK_GOAL + ' days in a row to unlock free shipping.</small>');
      bindCopy(streakEl);
    }
    paintStreak();

    if (state.date === today()) {
      body.innerHTML = '<p class="cbgd-fb">Today\'s round is complete' + (state.age ? ' (' + AGE_LABEL[state.age] + ' questions)' : '') + '. You scored <strong>' + state.score + '/3</strong>.</p>' +
        (state.score === 3 ? rewardHTML(CODES.daily, 'Your 10% code:') : '<p>Come back tomorrow for a new round!</p>');
      bindCopy(body); return;
    }
    var items = pick(BANK[a], dayIndex(), 3), n = 0, score = 0;
    function next() {
      if (n === items.length) {
        var yd = new Date(); yd.setDate(yd.getDate() - 1);
        var yKey = yd.getFullYear() + '-' + (yd.getMonth() + 1) + '-' + yd.getDate();
        streak = { count: streak.last === yKey ? streak.count + 1 : 1, last: today() };
        set('streak', streak); set('daily', { date: today(), score: score, age: a }); paintStreak();
        body.innerHTML = '<p class="cbgd-fb">You scored <strong>' + score + '/3</strong>.</p>' +
          (score === 3 ? rewardHTML(CODES.daily, '🎉 Perfect round! Take 10% off:') : '<p>Get all three right for 10% off. New questions tomorrow — and don\'t forget the Riddle of the Week!</p>');
        bindCopy(body); return;
      }
      var h = el('p', 'cbgd-count', 'Question ' + (n + 1) + ' of 3');
      var qc = el('div');
      body.innerHTML = ''; body.appendChild(h); body.appendChild(qc);
      renderQuestion(qc, items[n], function (ok) { if (ok) score++; n++; next(); });
    }
    next();
  }

  function initRiddle(root) {
    var body = root.querySelector('.cbgd-body');
    var wk = weekIndex();
    var state = get('riddle') || {};
    var a = age();
    var tag = root.querySelector('.cbgd-age-now');
    if (tag) tag.textContent = AGE_LABEL[a] + ' riddle';
    if (state.week === wk) {
      body.innerHTML = state.won ? rewardHTML(CODES.riddle, 'Your 15% riddle code:') : '<p class="cbgd-fb">You\'ve attempted this week\'s riddle. A new one arrives Sunday!</p>';
      bindCopy(body); return;
    }
    var list = RIDDLES[a];
    renderQuestion(body, list[wk % list.length], function (ok) {
      set('riddle', { week: wk, won: ok, age: a });
      var out = el('div');
      out.innerHTML = ok ? rewardHTML(CODES.riddle, '🏆 Riddle solved! Take 15% off:') : '<p class="cbgd-fb">Tough one! A new riddle arrives Sunday.</p>';
      body.appendChild(out); bindCopy(body);
    });
  }

  function initAges(root) {
    var btns = root.querySelectorAll('[data-cbgd-age]');
    function paint() {
      var a = age();
      btns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-cbgd-age') === a)); });
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        set('age', b.getAttribute('data-cbgd-age'));
        paint();
        document.querySelectorAll('[data-cbgd-daily]').forEach(initDaily);
        document.querySelectorAll('[data-cbgd-riddle]').forEach(initRiddle);
      });
    });
    paint();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-cbgd-ages]').forEach(initAges);
    document.querySelectorAll('[data-cbgd-quick]').forEach(initQuick);
    document.querySelectorAll('[data-cbgd-daily]').forEach(initDaily);
    document.querySelectorAll('[data-cbgd-riddle]').forEach(initRiddle);
  });
})();
